var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 56,
    viewBox: "0 0 28 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.55078 42.082C8.37989 42.253 8.11598 42.2738 7.92188 42.1455L7.84375 42.082L6.78418 41.0225C6.61363 40.8518 6.59201 40.5885 6.71973 40.3945L6.78418 40.3154L18.7334 28.3643L19.0869 28.0107L6.78223 15.7061C6.61138 15.535 6.59017 15.2712 6.71875 15.0771L6.78223 14.999L7.84375 13.9395C8.01453 13.7689 8.27774 13.7472 8.47168 13.875L8.5498 13.9395L21.3281 26.7129L21.3291 26.7139L21.4502 26.8467C21.5265 26.9392 21.5937 27.0389 21.6504 27.1445L21.7275 27.3066C21.8199 27.5287 21.8672 27.7673 21.8672 28.0078C21.8671 28.1882 21.8405 28.3672 21.7881 28.5391L21.7275 28.708C21.6583 28.8745 21.5645 29.0294 21.4502 29.168L21.3291 29.3008L21.3281 29.3027L8.55078 42.082Z",
    fill: "#1C4F36",
    stroke: "#1C4F36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.9b3720481fcd44e624d1c5df9c45b583.svg";
export { ForwardRef as ReactComponent };